package com.cybersoftsolution.cybersoftsolutionweb.components.sections


import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.cybersoftsolution.cybersoftsolutionweb.components.bars.SearchBarCollapsable
import com.cybersoftsolution.cybersoftsolutionweb.components.bars.SearchBarNoCollapsable
import com.cybersoftsolution.cybersoftsolutionweb.components.cards.MyPosition
import com.cybersoftsolution.cybersoftsolutionweb.components.icons.MyFaIcon
import com.cybersoftsolution.cybersoftsolutionweb.components.menus.OffCanvasPanel
import com.cybersoftsolution.cybersoftsolutionweb.components.menus.ToggleOffCanvasPanelElement
import com.cybersoftsolution.cybersoftsolutionweb.components.items.SectionItem
import com.cybersoftsolution.cybersoftsolutionweb.models.Category
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.models.UserInfo
import com.cybersoftsolution.cybersoftsolutionweb.pages.admin.Device.isDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.HeaderSectionLinearGradientStyleDesktop
import com.cybersoftsolution.cybersoftsolutionweb.styles.HeaderSectionLinearGradientStyleMobile
import com.cybersoftsolution.cybersoftsolutionweb.styles.MyMenuIconStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.Scale_Selected_ItemStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SearchBarCollapsableStyle
import com.cybersoftsolution.cybersoftsolutionweb.styles.SubscribeBarCollapsableStyle
import com.cybersoftsolution.cybersoftsolutionweb.utils.BorderBoxSizeElementObserver
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.headerSectionHeight
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.searchTextFieldId
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.overflowX
import com.varabyte.kobweb.compose.css.whiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.aspectRatio
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.flexGrow
import org.jetbrains.compose.web.css.flexShrink
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.dom.Div
import org.w3c.dom.Element
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement
import org.w3c.dom.events.Event
import kotlin.collections.forEach
import kotlin.math.abs


fun Element.hasHorizontalScrollbar(): Boolean {
    return this.scrollWidth > this.clientWidth
}

fun Element.isElementPartiallyHidden(): Boolean {
    val rect = this.getBoundingClientRect()
    val windowHeight = window.innerHeight.toDouble()
    val windowWidth = window.innerWidth.toDouble()

    return (
            rect.top < 0 ||
                    rect.left < 0 ||
                    rect.bottom > windowHeight ||
                    rect.right > windowWidth
            )
}

fun getElementFullWith(id: String): Int {
    val htmlElement = document.getElementById(id) as? HTMLElement ?: return 0
    return htmlElement.getBoundingClientRect().width.toInt()
}








@Composable
fun HeaderSection(
    authenticatedUserInfo: UserInfo? = null,
    sections: List<PageSection>,
    setSectionVisibility: (id: String,visible: Boolean) -> Unit,
    pageSection: PageSection,
    menuIcon: Resources.FaIconsClassName? = null,
    brandIcon: String? = null,
    brandLogo: String? = null,
    searchText: String = "",
    setSearchText: (String) -> Unit = {},
    onSearch: (text: String,category: String?) -> Unit = { _, _ -> },
    searchCategory: Category? = null,
    onMenuClick: () -> Unit = {},
    displayAuthenticationDialog: () -> Unit = {}

) {
    val scope = rememberCoroutineScope()
    val context = rememberPageContext()
    val breakpoint = rememberBreakpoint()

    var rightRowWidth by remember { mutableStateOf(0) }
    var forceUpdate by remember { mutableStateOf(false) }
    var previewAvailableWidth by remember { mutableStateOf(10000) }


    var headerVisible by remember { mutableStateOf(true) }
    var lastScrollTop by remember { mutableStateOf(0) }

    DisposableEffect(Unit) {
        val scrollListener = { _: Event ->
            val scrollTop = window.pageYOffset
            if (abs(scrollTop - lastScrollTop) > 20){
                if (scrollTop > lastScrollTop && scrollTop > headerSectionHeight.value.toInt()) {
                    headerVisible = false
                } else if (scrollTop < lastScrollTop || scrollTop <= headerSectionHeight.value.toInt()) {
                    headerVisible = true
                }
                lastScrollTop = scrollTop.toInt()
            }
//            console.log("headerVisible[$headerVisible] scrollTop[$scrollTop]")
        }
        window.addEventListener("scroll", scrollListener)
        onDispose {
            window.removeEventListener("scroll", scrollListener)
        }
    }



    fun getCurrentWithOfVisibleElements():Int{
        var currentWidth = 0
        sections.filter { it.visible } .forEach { section ->
            val itemWidth = getElementFullWith(section.id.orEmpty())
            currentWidth += itemWidth +10
        }
        return currentWidth
    }

    fun getNextHiddenElementWidth():Int{
        return sections.firstOrNull{!it.visible}?.let {getElementFullWith(it.id.orEmpty())}?:0
    }


    // Function to update visibility of items
    fun updateItemVisibility(increasing: Boolean) {

            scope.launch {
//                updating = true

//                Another method
//                console.log("Increasing[$increasing] | getCurrentWithOfVisibleElements[${getCurrentWithOfVisibleElements()}] |  getNextHiddenElementWidth[${getNextHiddenElementWidth()}] | availableWidth[${availableWidth}]")
//                val idsVisibles = mutableListOf<String>()
//                var sumaAnchos = 0
//                var i = 0
//                repeat(sections.size) {
//                    sumaAnchos += getElementFullWith(sections[i].id)
//                    if (sumaAnchos < rightRowWidth) {
//                        idsVisibles.add(sections[i].id)
//                    }
//                    i++
//                }
//                sections.forEach { section ->
//                    setSectionVisibility(section.id,idsVisibles.contains(section.id))
//                }


                if (increasing) {
//                    console.log("Increasing")
                    while ((getCurrentWithOfVisibleElements()+getNextHiddenElementWidth()) < rightRowWidth ) {

                        sections.firstOrNull{!it.visible}?.let {
                            setSectionVisibility(it.id.orEmpty(),true)
                        }?:(break)
                    }
                } else {
//                    console.log("Decreasing")
                    while (rightRowWidth < getCurrentWithOfVisibleElements() ) {
                        sections.lastOrNull{it.visible}?.let {
                            setSectionVisibility(it.id.orEmpty(),false)
                        }?:(break)
                    }
                }
            }


    }


    val desktop = isDesktop()
    var rememberStyle by remember { mutableStateOf(
        if (desktop) {
            HeaderSectionLinearGradientStyleDesktop
        } else {
            HeaderSectionLinearGradientStyleMobile
        }
    ) }

    LaunchedEffect(breakpoint) {
        rememberStyle =         if (desktop) {
            HeaderSectionLinearGradientStyleDesktop
        } else {
            HeaderSectionLinearGradientStyleMobile
        }
    }

    val shadowStyle = Modifier
        .boxShadow(
            offsetX = 0.px,
            offsetY = 4.px,
            blurRadius = 8.px,
            spreadRadius = 2.px,
            color = Theme.HalfBlack.rgb
        )

//    Animate

    Row(
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
        modifier = rememberStyle.toModifier()
            .id(pageSection.name)
            .position(Position.Fixed)
            .fillMaxWidth()
            .height(headerSectionHeight)
            .padding(leftRight = if (isDesktop()) {30.px} else {10.px})
            .then(shadowStyle)
            .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
            .transform {
                translateY(if (headerVisible) 0.percent else (-100).percent) // Transforma la posición vertical
            }

            .zIndex(10) //posicionamiento de panel lateral sobre el contenido principal
    ) {



        Row(
            horizontalArrangement = Arrangement.Start,
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier
                .fillMaxHeight()
                .id("leftRow")
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
//                .thenIf(
//                    condition = !isDesktop(),
//                    other = Modifier
//                        .scale(0.7)
//                )
//                .styleModifier {
//                    flexShrink(0) // Prevent this Row from shrinking
//                }


        ){


            menuIcon?.let {
                MyFaIcon(
                    id = "menuIconId",
                    modifier = Modifier
                        .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                        .margin(right = if (isDesktop()) 15.px else 8.px),
                    style = MyMenuIconStyle,
                    faIconsClassName = it ,
                    size = 24,
                    onClick = { onMenuClick() }
                )

            }

            brandIcon?.let {
                Image(
                    modifier = Modifier
                        .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                        .width(if (isDesktop()) 80.px else 60.px),
                    src = it,
                    alt = "Ico",
                )
            }

            brandLogo?.let {
                Image(
                    modifier = Modifier
                        .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
                        .width(if (isDesktop()) 210.px else 190.px),
                    src = it,
                    alt = "Brand",
                )
            }




        }





        Row(
            modifier = Modifier
                .id("rightRow")
                .fillMaxSize()
                .whiteSpace(WhiteSpace.Normal)
                .overflow(Overflow.Hidden)
                .scrollBehavior(ScrollBehavior.Smooth)
                .position(Position.Static)
                .transition(Transition.of(property = TransitionProperty.All, duration = 300.ms))
        ) {

            Row(
                horizontalArrangement = Arrangement.End,
                verticalAlignment = Alignment.CenterVertically,
                modifier = Modifier
                    .fillMaxHeight()
                    .weight(1f) // Assign remaining space
                    .transition(
                        Transition.of(
                            property = TransitionProperty.All,
                            duration = 300.ms
                        )
                    )
                    .styleModifier {
                        flexGrow(1) // Allow this Row to expand and fill remaining space
                        flexShrink(0)
                        overflowX(Overflow.Hidden) // Enable
                        whiteSpace(WhiteSpace.Normal) // Prevent
                    }
                    .whiteSpace(WhiteSpace.Normal)
                    .overflow(Overflow.Hidden)
//                    .overflow(Overflow.Auto)
                    .scrollBehavior(ScrollBehavior.Smooth)
                    .position(Position.Static)

            ) {


                sections.filter { it.visible }.forEach { section ->
                        SectionItem(
                            id = section.id.orEmpty(),
//                            visible = section.visible,
                            selected = false,
                            title = section.text,
                            icon = section.icon,
                            onClick = {
                                if (section.name == "HeaderSection") {
                                    window.scrollTo(0.0, 0.0)
                                } else {
                                    context.router.navigateTo("#${section.name}")
                                }

//                                context.router.navigateTo("#${section.id.orEmpty()}content")
//                                context.router.navigateTo(section.route)

                            },
                        )


                }

            }




        }

        if (sections.any { !it.visible }) {

            ToggleOffCanvasPanelElement(
                modifier = Modifier
                    .padding(leftRight = 20.px),
                id = "sectionHiddenMenuId",
                offCanvasPanelId = "sectionHiddenMenuPanelId",
            ){
                MyFaIcon(

                    style = Scale_Selected_ItemStyle,
                    id = "sectionHiddenMenuIconId",
                    faIconsClassName = Resources.FaIconsClassName.VerticalDotts_ICO ,
                    size = 24,
                )
            }

        }

        if (isDesktop()) {
            SearchBarCollapsable(
                modifier = Modifier
                    .margin(left = 10.px),
//            enabled = !isSearching,
                maxWidth = 250,
                searchText = searchText,
                id = searchTextFieldId, //_BoxContainer
                onSearchTextChange = {
                    setSearchText(it)
                },
                style = SearchBarCollapsableStyle,
//                    isSearching = isSearching,
//                    setSearching = {
//                        isSearching = it
//                    },
//            categories = Category.entries.map { if (it== Category.NoCategory) {"Any"} else {it.name} },
                onSearch = { text, category ->
                    onSearch(text, category)
                },
                refreshUpdateItemVisibility = { //increasing ->
                    scope.launch {
                        delay(50)
                        rightRowWidth = (document.getElementById("rightRow") as? HTMLDivElement)?.offsetWidth ?: 0
                        forceUpdate = !forceUpdate
                    }


                }

            )
        }


        var isHovered by remember { mutableStateOf(false) }

        Box(
            contentAlignment = Alignment.Center,
            modifier = Scale_Selected_ItemStyle.toModifier()
                .id("authenticatedUserImageId")
                .margin(leftRight = 20.px)
                .cursor(Cursor.Pointer)
                .onClick {
                    displayAuthenticationDialog()
                }
                .aspectRatio(1)
                .fillMaxHeight(60.percent)
                .position(Position.Relative)
                .onMouseEnter { isHovered = true } // Detecta cuando el mouse entra
                .onMouseLeave { isHovered = false }  // Detecta cuando el mouse sale
        ) {


            Image(
                modifier = Modifier
                    .fillMaxSize()
                    .thenIf(
                        condition = !authenticatedUserInfo?.picture.isNullOrEmpty(),
                        other = Modifier.border(
                            width = 2.px,
                            style = LineStyle.Solid,
                            color = Theme.HalfWithe.rgb
                        )
                    )
                    .borderRadius(100.px), // Bordes redondeados para la imagen,
                src = authenticatedUserInfo?.picture ?: Resources.Images.profilePlaceholder,
                alt = "Imagen de perfil",
            )



            if (isHovered) { // Muestra el overlay solo si el mouse está encima
                Div(
                    attrs = Modifier
                        .fillMaxSize()
                        .borderRadius(100.px) // Bordes redondeados para la imagen
                        .backgroundColor(rgba(255, 255, 255, 0.2))
                        .position(Position.Absolute)
                        .top(0.px)
                        .left(0.px)
                        .toAttrs()
                )
            }
        }

//        Image(
//            modifier = Scale_Selected_ItemStyle.toModifier()
////                    then(shadowStyle)
//                .id("authenticatedUserImageId")
//                .margin(leftRight = 20.px)
//                .cursor(Cursor.Pointer)
//                .transition(Transition.of(property = TransitionProperty.All, duration = 150.ms))
//                .onClick {
//                    showAuthentication(true)
//                }
//                .aspectRatio(1)
//                .fillMaxHeight(60.percent)
//                .borderRadius(50.px)
//
//
//            ,
//            src = Resources.Images.skills,
//            alt = "Imagen de perfil",
//        )









    }
    OffCanvasPanel(
        style = Scale_Selected_ItemStyle,
        id = "sectionHiddenMenuPanelId",
        title = "",
        position = MyPosition.end,
        enableScrolling = true,
        overlays = true,
        showModal = false,

        ){
        Column(
            modifier = Modifier
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally

        ) {

            if (!isDesktop()) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier.fillMaxWidth()

                ) {
                    SearchBarNoCollapsable(
                        searchText = searchText,
                        id = searchTextFieldId, //_BoxContainer
                        onSearchTextChange = {
                            setSearchText(it)
                        },
                        style = SubscribeBarCollapsableStyle,
                        onSearch = { text, category ->
                            onSearch(text, category)
                        },
                    )
                }

            }


            sections.filter { !it.visible }.forEach { section ->
                ToggleOffCanvasPanelElement(
                    id = "sectionHiddenMenuId",
                    offCanvasPanelId = "sectionHiddenMenuPanelId",
                ){
                    SectionItem(
                        modifier = Modifier
                            .fillMaxWidth()
                            .margin(topBottom = 10.px),
                        id = section.id.orEmpty(),//+"_offCanvasPanel",
//                                        visible = true,
                        selected = false,
                        title = section.text,
                        icon = section.icon,
                        onClick = {
                            if (section.name == "HeaderSection") {
                                window.scrollTo(0.0, 0.0)
                            } else {
                                context.router.navigateTo("#${section.name}")
                            }
//                            context.router.navigateTo("#${section.name}")
                        },
                    )
                }


            }
        }


    }



    LaunchedEffect( key1 = breakpoint, key2 = rightRowWidth,key3 = forceUpdate) {
        val availableWidth = rightRowWidth
        val increasing = previewAvailableWidth < availableWidth
        previewAvailableWidth = availableWidth
        updateItemVisibility(increasing)
    }


    LaunchedEffect(Unit,breakpoint) {

        //Obtener el ancho del elemento por primera vez
        rightRowWidth = (document.getElementById("rightRow") as? HTMLDivElement)?.offsetWidth ?: 0


        //Observar el ancho del elemento
        BorderBoxSizeElementObserver.observeElementById("rightRow")

        BorderBoxSizeElementObserver.widthChangeFlow.collect { (id, elementWidth) ->
            when (id) {
                "rightRow" -> {
//                        if (abs(elementWidth-previewAvailableWidth) > 5) {
                            rightRowWidth = elementWidth
//                            console.log(  "rightRow -> elementWidth[${elementWidth}]" )
//                        }
                    }

                }
            }

    }



//     ... DisposableEffect para dejar de observar el ancho del elemento
    DisposableEffect(Unit) {
        onDispose {
            BorderBoxSizeElementObserver.unObserveElementById("rightRow")
        }
    }



}



